<script>
export default {
  name: 'Relatorios',
  inject: ['page', 'erplayout'],
  mixins: [],
  components: {},
  data() {
    return {
      avancado: false,
      configs: [],
      config: {}
    }
  },
  computed: {},
  methods: {
  },
  meta: {
    title: 'Relatórios',
    name: 'Relatorios'
  }
}
</script>

<template>
  <div class="sl-alert-warning">
    <p><i class="fa fa-exclamation-triangle"></i> Seja bem vindo ao novo módulo de relatórios da Suporte Leilões</p>
    Os relatórios antigos continuam sendo visualizados da forma antiga, estaremos atualizando-os aos poucos. Selecione o relatório no menu ao lado.
  </div>
</template>
